// src/redux/actions/salesActions.js
import {
    FETCH_EXISTING_DEMO_SESSION_REQUEST,
    FETCH_EXISTING_DEMO_SESSION_SUCCESS,
    FETCH_EXISTING_DEMO_SESSION_FAILURE,
    CLEAR_EXISTING_DEMO_SESSION
} from '../../../../Constants/actionTypes';
import { fetchExistingDemoSession } from '../../../../Constants/apiService'


// Fetch Sales Request Action
export const fetchExistingDemoSessionRequest = () => ({
    type: FETCH_EXISTING_DEMO_SESSION_REQUEST,
});

// Fetch Sales Success Action
export const fetchExistingDemoSessionSuccess = (salesData) => ({
    type: FETCH_EXISTING_DEMO_SESSION_SUCCESS,
    payload: salesData,

});

// Fetch Sales Failure Action
export const fetchExistingDemoSessionFailure = (error) => ({
    type: FETCH_EXISTING_DEMO_SESSION_FAILURE,
    payload: error,
});


// Action to clear the ExistingDemoSession
export const clearExistingDemoSession = () => ({
    type: CLEAR_EXISTING_DEMO_SESSION,
});

// Thunk Action Creator for Fetching Sales
export const fetchExistingDemoSessionAct = (id) => {
    return async (dispatch, getState) => {
        dispatch(fetchExistingDemoSessionRequest());

        const state = getState();
        const accessToken = state.auth.accessToken;


        try {
            const data = await fetchExistingDemoSession(accessToken,id);
            console.log(data)
            const responseWithType = { ...data, type: 'ExistingSession' };
            dispatch(fetchExistingDemoSessionSuccess(responseWithType));
            return responseWithType;
        } catch (error) {
            let errorMessage;
            if (error.message === 'Failed to fetch' || error.message.includes('NetworkError')) {
                errorMessage = 'Server is currently down. Please try again later.';
            } else {
                errorMessage = error.message;
            }
            dispatch(fetchExistingDemoSessionFailure(errorMessage));
        }
    };
};
